import React, { useCallback, useEffect, useState } from "react";
import moment from "moment";
import ApiHelper from "../../helper/api-helper";
import ApiUrls from "../../helper/api-urls";
import { NotificationManager } from "src/util/notify";
import DropDownKendoRct from "../../control-components/drop-down/drop-down";
import InputKendoRct from "../../control-components/input/input";
import { Switch } from "@progress/kendo-react-inputs";
import ErrorHelper from "../../helper/error-helper";
import { Loader } from "@progress/kendo-react-indicators";
import DatePickerKendoRct from "../../control-components/date-picker/date-picker";

const FilterModel = ({ fetchFromParent, setLoading, onMasterClinicIdChange }) => {
  const [allClinic, setAllClinic] = useState([]);
  const [errors, setErrors] = useState("");
  const [staffError, setStaffError] = useState(false);

  const [fields, setFields] = useState({
    clinicId: "",
    staffIds: [],
    startDate: moment().subtract(3, "days").startOf("day").toISOString(),
    endDate: moment().endOf("day").toISOString(),
    isActive:false,
    messagePart: "",
    logLevel: "",
    logGroupName: "",

  });

  
  useEffect(() => {
    
    getAllClinic(fields.isActive);
    handleFilter();
  }, []);

  const getAllClinic = async (isActive) => {
    
    
    ApiHelper.getRequest(ApiUrls.ALL_CLINIC_BY_ACTIVE+isActive)
      .then((result) => {
        
        let staffAuditActions = result.resultData;
        setAllClinic(staffAuditActions);

      })
      .catch((error) => {

        NotificationManager.error(error.message);
      });
  };

  const handleChange = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    setFields((prevFields) => {
      if (name === "staffIds") {
        const staffIdList = value ? [parseInt(value)] : [];
        return { ...prevFields, staffIds: staffIdList };
      } else {
        return { ...prevFields, [name]: value };
      }
    });
    if (name === "isActive") {
      getAllClinic(value);
    }
    if (name === "clinicId") {
      onMasterClinicIdChange(value?.id);
    }
  };

  const handleValidation = () => {
    let errors = {};
    let formIsValid = true;
    setErrors(errors);
    return formIsValid;
  };

  const handleFilter = () => {

    setLoading(true);

    if (handleValidation()) {
      const data = {
        staffIds: fields.staffIds.length === 0 ? [] : fields.staffIds,
        startDate: fields.startDate,
        endDate: fields.endDate,
      };
  
      
      if (fields.clinicId && fields.clinicId.id) data.clinicId = fields.clinicId.id;
      if (fields.messagePart) data.messagePart = fields.messagePart;
      if (fields.logLevel) data.logLevel = fields.logLevel;
      if (fields.logGroupName) data.logGroupName = fields.logGroupName;
  
      ApiHelper.postRequest(ApiUrls.GET_CLOUDWATCH_LOGS, data)
        .then((result) => {
          
          fetchFromParent(result.resultData);
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          NotificationManager.error(error.message);
        });
    }
  };

  const handleClear = useCallback(() => {
    setFields({
      clinicId: "",
      staffIds: [],
      startDate: moment().subtract(3, "days").startOf("day").toISOString(),
      endDate: moment().endOf("day").toISOString(),
      isActive: false,
      messagePart: "",
      logLevel: "",
      logGroupName: "",
    });
    onMasterClinicIdChange(null); 
  }, [onMasterClinicIdChange]);

  return (
    <>
      
      <div className="row align-items-end">
        <div className="col-lg-3 col-md-6 col-12 mb-3 edit-Service-popup">
          <DropDownKendoRct
            validityStyles={staffError}
            onChange={handleChange}
            data={allClinic}
            value={fields.clinicId}
            textField="clinicName"
            name="clinicId"
            label="Clinic"
            error={fields.clinicId === "" && errors.clinicId}
          />
        </div>
        <div className="col-lg-3 col-md-6 col-12 mb-3">
          <InputKendoRct
            value={fields.staffIds[0] || ""}
            onChange={handleChange}
            name="staffIds"
            label="Staff Id"
            className="form-control"
            placeholder="Staff Id"
            type="number"
          />
        </div>
        <div className="col-lg-3 col-md-6 col-12 mb-3 date-field ">
          <label className="form-label" style={{ fontSize: "0.875rem" }}>
            Start Date
          </label>
          <DatePickerKendoRct
            value={new Date(fields.startDate)}
            name="startDate"
            onChange={handleChange}
          />
        </div>
        <div className="col-lg-3 col-md-6 col-12 mb-3 date-field">
          <label className="form-label" style={{ fontSize: "0.875rem" }}>
            End Date
          </label>
          <DatePickerKendoRct
            value={new Date(fields.endDate)}
            onChange={handleChange}
            name="endDate"
          />
        </div>
        <div className="col-lg-3 col-md-6 col-12 mb-3">
          <InputKendoRct
            value={fields.messagePart}
            onChange={handleChange}
            name="messagePart"
            label="Message Part"
            className="form-control"
            placeholder="Message Part"
          />
        </div>
        <div className="col-lg-3 col-md-6 col-12 mb-3">
          <InputKendoRct
            value={fields.logLevel}
            onChange={handleChange}
            name="logLevel"
            label="Log Level"
            className="form-control"
            placeholder="Log Level"
          />
        </div>
        <div className="col-lg-3 col-md-6 col-12 mb-3 ">
          <InputKendoRct
            value={fields.logGroupName}
            onChange={handleChange}
            name="logGroupName"
            label="Log Group Name"
            className="form-control"
            placeholder="Log Group Name"
          />
        </div>
        <div className="col-lg-2 col-md-6 col-12 mb-3">
          <div className="d-flex justify-content-between align-items-center">
            <button className="green-btn btn-primary mr-2" onClick={handleFilter}>
              Filter
            </button>
            <button className="btn" onClick={handleClear}>
              Clear
            </button>
          </div>
        </div>
        <div className="col-lg-1 col-md-6 col-12 mb-3">
          <div className="d-flex align-items-center">
            <Switch
              onChange={handleChange}
              checked={fields.isActive}
              name="isActive"
              onLabel="yes"
              offLabel="no"
            />
            <span className="switch-title-text fw-600 f-16 ml-2">Active</span>
          </div>
        </div>
      </div>
    </>
  );
};

export default FilterModel;
